import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const ZoomSlider = ({
  zoom, onZoomChange, onInfoPress, minZoom = 1, maxZoom = 5, step = 1,
  bottomControls, torchEnabled, onTorchToggle, onSwitchCamera, onClose,
  hasMultipleCameras, hasTorch,
}) => {
  const increaseZoom = () => {
    if (!onZoomChange) return;
    const newZoom = Math.min(zoom + step, maxZoom);
    onZoomChange(newZoom);
  };

  const decreaseZoom = () => {
    if (!onZoomChange) return;
    const newZoom = Math.max(zoom - step, minZoom);
    onZoomChange(newZoom);
  };

  if (bottomControls) {
    return (
      <View style={styles.container}>
        <View style={styles.zoomControls}>
          <TouchableOpacity onPress={decreaseZoom} testID="zoomOut">
            <Text style={styles.sideButton}>-</Text>
          </TouchableOpacity>

          <View style={styles.zoomValueWrapper}>
            <Text style={styles.currentZoom}>{zoom}x</Text>
          </View>

          <TouchableOpacity onPress={increaseZoom} testID="zoomIn">
            <Text style={styles.sideButton}>+</Text>
          </TouchableOpacity>
        </View>

        <View style={[
          styles.cameraControls,
          !hasMultipleCameras && { gap: 92 },
        ]}>
          {hasMultipleCameras && (
            <TouchableOpacity style={styles.controlButton} onPress={onSwitchCamera} testID="switchCameraButton">
              <Ionicons name="camera-reverse" size={22} color="#fff" />
            </TouchableOpacity>
          )}
          {hasTorch && (
            <TouchableOpacity style={styles.controlButton} onPress={onTorchToggle} testID="torchButton">
              <Ionicons name={torchEnabled ? "flash" : "flash-off"} size={22} color="#fff" />
            </TouchableOpacity>
          )}
          <TouchableOpacity style={styles.controlButton} onPress={onClose} testID="closeButton">
            <Ionicons name="close" size={22} color="#fff" />
          </TouchableOpacity>
        </View>

        {onInfoPress && (
          <TouchableOpacity onPress={onInfoPress} style={styles.infoButton} testID="infoButton">
            <Ionicons name="information-circle" size={24} color="#fff" />
          </TouchableOpacity>
        )}
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <View style={styles.zoomControls}>
        <TouchableOpacity onPress={decreaseZoom} testID="zoomOut">
          <Text style={styles.sideButton}>-</Text>
        </TouchableOpacity>

        <View style={styles.zoomValueWrapper}>
          <Text style={styles.currentZoom}>{zoom}x</Text>
        </View>

        <TouchableOpacity onPress={increaseZoom} testID="zoomIn">
          <Text style={styles.sideButton}>+</Text>
        </TouchableOpacity>
      </View>

      {onInfoPress && (
        <TouchableOpacity onPress={onInfoPress} style={styles.infoButton} testID="infoButton">
          <Ionicons name="information-circle" size={24} color="#fff" />
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: 5,
    left: 10,
    right: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    zIndex: 10,
  },
  cameraControls: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0,0,0,0.5)',
    borderRadius: 25,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.3)',
    paddingHorizontal: 12,
    paddingVertical: 2,
    marginHorizontal: 8,
    gap: 35,
  },
  zoomControls: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.5)',
    borderRadius: 25,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.3)',
    paddingHorizontal: 10,
  },
  zoomValueWrapper: {
    minWidth: 30,
    alignItems: 'center',
  },
  currentZoom: {
    color: '#fff',
    fontSize: 14,
    fontWeight: 'bold',
    textShadowColor: 'rgba(0, 0, 0, 0.75)',
    textShadowOffset: { width: -1, height: 1 },
    textShadowRadius: 5,
  },
  sideButton: {
    color: '#fff',
    fontSize: 22,
    fontWeight: 'bold',
    textAlign: 'center',
    textShadowColor: 'rgba(0,0,0,0.75)',
    textShadowOffset: { width: -1, height: 1 },
    textShadowRadius: 5,
    width: 20,
  },
  infoButton: {
    padding: 4,
  },
  controlButton: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default ZoomSlider;
